import { render, staticRenderFns } from "./portada.vue?vue&type=template&id=26ba418a&"
import script from "./portada.vue?vue&type=script&lang=js&"
export * from "./portada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports